import { BarChartOutlined } from '@ant-design/icons/lib';
import { SubPage } from '@symfa-inc/providence-verizon-types';
import { RedirectGuard } from '@core/guards';
import { tabPropsToTabs } from '@core/utils/methods';
import { Route, RouteGroup } from '@models/classes';
import { MenuPlacement } from '@models/enums';
import { ReportsBrowse, ReportTabContent } from './components';
import { REPORT_TABS } from './models';

export const reportsBrowseTabs = tabPropsToTabs(
  REPORT_TABS.map(({ key, title }) => ({
    component: ReportTabContent,
    componentProps: {
      reportKey: key,
    },
    name: title,
    path: `/${key}`,
  })),
);

export const reportsRoutes = new RouteGroup({
  name: 'Reports',
  path: '/reports',
})
  .setMenu(MenuPlacement.Main, BarChartOutlined)
  .breadcrumb()
  .addGuard(new RedirectGuard('exports'), '/')
  .addRoute(
    new Route({
      path: '/browse',
      name: 'Browse',
      component: ReportsBrowse,
    })
      .setMenu(MenuPlacement.Main)
      .addGuard(new RedirectGuard('exports', SubPage.ExportsBrowse), '/')
      .breadcrumb()
      .addTabs(reportsBrowseTabs),
  );
